<template>
  <div class="detail">
    <div class="header container">
      <view-back :hideBtn="$route.query.isPreview === '1'"></view-back>
    </div>
    <!--头部图片和展览信息-->
    <div class="top-image-box container">
      <div class="background-box">
        <img class="background" v-lazy="exhibitionData.cover" alt="">
      </div>
      <div class="cover"></div>
      <div class="content-box wrap">
        <div class="intro-box">
          <h2 id="exhibitionTitle">{{exhibitionData.title}}</h2>
          <h3>{{exhibitionData.subtitle ? ('——' + exhibitionData.subtitle) : ''}}</h3>
          <div class="museum clearfix" v-if="exhibitionData.museumObj">
            <!-- <img v-lazy="util.getPicUrl(exhibitionData.museumObj.headImg, 'imgsmall')" alt=""> -->
            <p>{{exhibitionData.applicationUnitName}}</p>
          </div>
          <ul>
            <li v-if="exhibitionData.ticket">票务信息：{{exhibitionData.ticket}}元</li>
            <li v-if="exhibitionData.curtainTime">展览日期：{{showTime}}</li>
            <li v-if="exhibitionData.address">展览地点：{{exhibitionData.address}}<i v-show="false && exhibitionData.address"></i></li>
            <li v-if="exhibitionData.exhibitionHall">所在展厅：{{exhibitionData.exhibitionHall}}</li>
            <li v-if="exhibitionData.sponsorUnit">主办单位：{{exhibitionData.sponsorUnit}}</li>
            <li v-if="exhibitionData.organizeUnit">承办单位：{{exhibitionData.organizeUnit}}</li>
          </ul>
        </div>
        <div class="cover-img">
          <img v-lazy="exhibitionData.cover" alt="">
        </div>
        <div class="pano-btn" v-if="exhibitionData.vrUrl" @click="toUrl(exhibitionData.vrUrl)">
          <i></i>
          <p>进入全景</p>
        </div>
        <div v-if="$route.query.isPreview !== '1'" class="zan-btn" @click="addZan">
          <div class="zan-image-box">
            <img v-show="!isZan" src="../assets/images/zan.png" alt="">
            <img v-show="isZan" src="../assets/images/zan-click.png" alt="">
            <p class="zan-num">{{exhibitionData.thumbNum}}</p>
            <p class="zan-tip" :class="{'like': isZan}">+1</p>
          </div>
          <p class="tip">点赞</p>
        </div>
      </div>
    </div>
    <!--展览介绍-->
    <div class="introduction wrap" v-if="exhibitionData.introduction">
      <div class="have-icon-title">展览介绍</div>
      <p ref="introduction" class="intro" :class="{'all': introShowAll}">{{exhibitionData.introduction}}</p>
      <span v-show="introductionShowBtn && !introShowAll" class="more-btn down" @click="introShowAll = true">展开</span>
      <span v-show="introductionShowBtn && introShowAll" class="more-btn up" @click="introShowAll = false">收起</span>
    </div>
    <!--展览视频-->
    <div class="video-swiper-box wrap" v-if="videoArray.length > 0">
      <div class="big-img">
        <swiper ref="videoSwiper" class="video-swiper" :options="videoSwiperOption">
          <swiper-slide class="slide" v-for="(item, index) in videoArray" :key="index">
            <div class="img" v-if="item.type === 'image'">
              <img v-lazy="util.getPicUrl(item.url, 'imgoriginal')" alt="" :key="item.url">
              <div class="cover">
                <p>{{item.name}}</p>
              </div>
            </div>
            <div class="video" v-if="item.type === 'video'">
              <img v-lazy="item.url" alt="">
              <!--<video :src="item.videoUrl"></video>-->
              <div class="cover">
                <p>{{item.name}}</p>
              </div>
              <div class="play-btn" @click="playVideo(item.videoUrl)"></div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="thumb-swiper-area">
        <div id="thumbSwiper" class="thumb-swiper swiper-container">
          <div class="swiper-wrapper">
            <div class="slide swiper-slide" :class="{'show': index === thumbSwiperActiveIndex}" v-for="(item, index) in videoArray" :key="index">
              <div v-if="item.type === 'image'">
                <img v-lazy="util.getPicUrl(item.url, 'thumbnail')" alt="" :key="item.url">
              </div>
              <div v-if="item.type === 'video'">
                <img v-lazy="item.url" alt="">
                <!--<video :src="item.videoUrl"></video>-->
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev1" slot="button-prev"></div>
        <div class="swiper-button-next1" slot="button-next"></div>
      </div>
    </div>
    <!--单元介绍-->
    <div class="unit-intro-box wrap" v-if="exhibitionData.unitArray && exhibitionData.unitArray.length > 0">
      <div class="have-icon-title">单元介绍</div>
      <div class="unit-swiper-box">
        <swiper ref="unitSwiper" class="unit-swiper" :options="unitSwiperOption">
          <swiper-slide class="slide" :class="{'active': index === unitIndex}" v-for="(unit, index) in exhibitionData.unitArray" :key="index">
            <div class="box">
              <img v-lazy="util.getPicUrl(unit.cover, 'imgsmall')" alt="" :key="unit.cover">
              <div class="cover">
                <p>{{unit.unitOrder}}</p>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div class="intro-box" v-if="exhibitionData.unitArray">
        <p class="title">{{exhibitionData.unitArray[unitIndex].title}}</p>
        <p ref="unitIntro" class="intro" :class="{'all': unitShowAll}">{{exhibitionData.unitArray[unitIndex].abstract}}</p>
        <span v-show="unitIntroShowBtn && !unitShowAll" class="more-btn down" @click="unitShowAll = true">展开</span>
        <span v-show="unitIntroShowBtn && unitShowAll" class="more-btn up" @click="unitShowAll = false">收起</span>
      </div>
    </div>
    <!--展品-->
    <div class="exhibits-area wrap">
      <div class="exhibits-box" v-if="antiqueSwiper && antiqueSwiper.length > 0">
        <div class="have-icon-title">展品</div>
        <swiper ref="exhibitSwiper" class="exhibit-swiper" :options="exhibitSwiperOption">
          <swiper-slide class="exhibit-line slide" v-for="(item, index) in antiqueSwiper" :key="index">
            <div class="img-box" @click="showImageCover(index)">
              <img v-lazy="util.getPicUrl(item.cover, 'imgsmall')" alt="" :key="item.cover">
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev2" slot="button-prev"></div>
        <div class="swiper-button-next2" slot="button-next"></div>
      </div>
    </div>
    <!--媒体资讯-->
    <div class="media-info-box wrap" v-if="exhibitionData.reportArray && exhibitionData.reportArray.length > 0">
      <div class="have-icon-title">媒体资讯</div>
      <ul class="clearfix" :class="{'all': mediaShowAll}">
        <li class="fl clearfix" v-for="(report, index) in exhibitionData.reportArray" :key="index" @click="toUrl(report.articleUrl)">
          <img v-lazy="util.getPicUrl(report.cover, 'imgsmall')" alt="" :key="report.cover">
          <div class="info-box">
            <h5 class="omitline3">{{report.title}}</h5>
            <p>{{report.articleDate}}</p>
          </div>
        </li>
      </ul>
      <span v-show="mediaShowBtn && !mediaShowAll" class="more-btn down" @click="mediaShowAll = true">展开</span>
      <span v-show="mediaShowBtn && mediaShowAll" class="more-btn up" @click="mediaShowAll = false">收起</span>
    </div>
    <!--社教活动-->
    <div class="media-info-box wrap" v-if="exhibitionData.activityArray && exhibitionData.activityArray.length > 0">
      <div class="have-icon-title">社教活动</div>
      <ul class="clearfix" :class="{'all': activeShowAll}">
        <li class="fl clearfix" v-for="(active, index) in exhibitionData.activityArray" :key="index" @click="showActiveInfo(active)">
          <img v-if="active.photos.length > 0" v-lazy="util.getPicUrl(active.photos[0].url, 'imgsmall')" alt="" :key="active.photos[0].url">
          <div class="info-box">
            <h5 class="omitline3">{{active.title}}</h5>
            <p>{{active.updateTime}}</p>
          </div>
        </li>
      </ul>
      <span v-show="activeShowBtn && !activeShowAll" class="more-btn down" @click="activeShowAll = true">展开</span>
      <span v-show="activeShowBtn && activeShowAll" class="more-btn up" @click="activeShowAll = false">收起</span>
    </div>
    <!--策展团队-->
    <div class="team-box wrap" v-show="!hidePeople" v-if="exhibitionData.projectLeader || (exhibitionData.planningTeam && exhibitionData.planningTeam.length > 0)">
      <div class="have-icon-title">策展团队</div>
      <div class="main-box" v-if="exhibitionData.projectLeader">
        <img src="../assets/images/xiangmu.png" alt="">
        <h3>{{exhibitionData.projectLeader.name}}</h3>
        <h4>{{exhibitionData.projectLeader.duty}}</h4>
        <p>在展览项目中主要贡献：</p>
        <p class="text">{{exhibitionData.projectLeader.contribution}}</p>
      </div>
      <div class="other-box" v-if="exhibitionData.planningTeam">
        <h4>团队成员</h4>
        <ul class="clearfix" :class="{'all': teamShowAll}">
          <li class="fl" v-for="(plan, index) in exhibitionData.planningTeam" :key="index">
            <img src="../assets/images/xiangmu.png" alt="">
            <h5 class="omitline1">{{plan.name}}</h5>
            <h6 class="omitline2">{{plan.duty}}</h6>
          </li>
        </ul>
        <span v-show="exhibitionData.planningTeam.length > 5 && !teamShowAll" class="more-btn down" @click="teamShowAll = true">查看更多</span>
        <span v-show="exhibitionData.planningTeam.length > 5 && teamShowAll" class="more-btn up" @click="teamShowAll = false">收起</span>
      </div>
    </div>
    <!--运营活动图片弹框-->
    <div class="img-cover-box" v-show="activeImgCoverShow">
      <div class="wrapBox wrap">
        <div class="cover-swiper-box">
          <swiper ref="activeSwiper" class="cover-swiper" :options="activeSwiperOption">
            <swiper-slide class="slide" v-for="(photo, index) in activeJson.photos" :key="index">
              <img class="loading" src="/gif/loading.gif" alt="">
              <img v-lazy="util.getPicUrl(photo.url, 'imgoriginal')" alt="" :key="photo.url">
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev4" slot="button-prev"></div>
          <div class="swiper-button-next4" slot="button-next"></div>
        </div>
        <div class="intro-box">
          <h2>{{activeJson.title}}</h2>
          <p>{{activeJson.introduction}}</p>
        </div>
      </div>
      <div class="close-btn" @click="hideActiveInfo"></div>
    </div>
    <!--图片弹框-->
    <div class="img-cover-box" v-show="imgCoverShow">
      <div class="wrapBox wrap">
        <div class="cover-swiper-box">
          <swiper ref="coverSwiper" class="cover-swiper" :options="coverSwiperOption">
            <swiper-slide class="slide" v-for="(antique, index) in antiqueSwiper" :key="index">
              <img class="loading" src="/gif/loading.gif" alt="">
              <img v-lazy="util.getPicUrl(antique.cover, 'imgoriginal')" alt="" :key="antique.cover">
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev3" slot="button-prev"></div>
          <div class="swiper-button-next3" slot="button-next"></div>
        </div>
        <div class="intro-box" v-if="antiqueSwiper.length > 0">
          <h2>{{antiqueSwiper[coverSwiperIndex].title}}</h2>
          <p>{{antiqueSwiper[coverSwiperIndex].date}}</p>
          <p>{{antiqueSwiper[coverSwiperIndex].size}}</p>
          <p v-if="antiqueSwiper[coverSwiperIndex].address">{{antiqueSwiper[coverSwiperIndex].address}}藏</p>
          <p>{{antiqueSwiper[coverSwiperIndex].content}}</p>
        </div>
      </div>
      <div class="close-btn" @click="imgCoverShow = false"></div>
    </div>
    <!--视频弹框-->
    <div class="video-cover-box" v-show="videoCoverShow">
      <div class="wrapBox wrap">
        <video :src="videoPlayUrl" controls autoplay></video>
      </div>
      <div class="close-btn" @click="closeVideo"></div>
    </div>
  </div>
</template>
<script>
import ViewBack from '../components/ViewBack'
let vm = null
export default {
  name: 'Detail',
  components: {
    'view-back': ViewBack
  },
  data () {
    return {
      id: this.$route.params.id,
      exhibitionData: {},
      unitIndex: 0,
      imgCoverShow: false,
      videoCoverShow: false,
      coverSwiperIndex: 0,
      thumbSwiperActiveIndex: 0,
      videoSwiperOption: {
        thumbs: {
          swiper: {
            el: '#thumbSwiper',
            slidesPerView: 5,
            watchSlidesVisibility: true, // 防止不可点击
            navigation: {
              nextEl: '.swiper-button-next1',
              prevEl: '.swiper-button-prev1'
            }
          },
          slideThumbActiveClass: 'my-slide-thumb-active'
        },
        on: {
          slideChangeTransitionStart: function () {
            vm.thumbSwiperActiveIndex = this.realIndex
          }
        }
      },
      // thumbSwiperOption: {
      //   slidesPerView: 5,
      //   watchSlidesVisibility: true, // 防止不可点击
      //   navigation: {
      //     nextEl: '.swiper-button-next',
      //     prevEl: '.swiper-button-prev'
      //   }
      // },
      unitSwiperOption: {
        slidesPerView: 'auto',
        lazy: {
          loadPrevNext: true
        },
        on: {
          slideChangeTransitionStart: function () {
            vm.unitSlideChange(this.realIndex)
            vm.checkUnitShowBtn()
          },
          tap: function () {
            if (this.clickedIndex !== undefined) {
              vm.unitSlideChange(this.clickedIndex)
              vm.checkUnitShowBtn()
              setTimeout(() => {
                this.slideTo(this.clickedIndex, 300, false)
              }, 30)
            }
          }
        }
      },
      exhibitSwiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // lazy: {
        //   loadPrevNext: true
        // },
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2'
        },
        on: {
          slideChangeTransitionEnd: function () {
            this.update()
          }
        }
      },
      coverSwiperOption: {
        navigation: {
          nextEl: '.swiper-button-next3',
          prevEl: '.swiper-button-prev3'
        },
        on: {
          slideChangeTransitionStart: function () {
            vm.coverSwiperIndex = this.realIndex
          }
        }
      },
      activeSwiperOption: {
        navigation: {
          nextEl: '.swiper-button-next4',
          prevEl: '.swiper-button-prev4'
        }
      },
      antiqueSwiper: [],
      topList: [],
      bottomList: [],
      topListWidth: 0,
      topListHeight: 250,
      bottomListWidth: 0,
      bottomListHeight: 175,
      introShowAll: true,
      unitShowAll: true,
      teamShowAll: false,
      introductionShowBtn: false,
      unitIntroShowBtn: false,
      mediaShowBtn: true,
      mediaShowAll: false,
      activeShowBtn: true,
      activeShowAll: false,
      activeImgCoverShow: false,
      activeJson: {},
      isZan: false,
      videoArray: [],
      videoPlayUrl: '',
      hidePeople: false
    }
  },
  created () {
    vm = this
  },
  mounted () {
    this.getDetailInfo()
    if (this.$route.query.isPreview !== '1') {
      this.$api.addExhibitionViewNum(this.id)
      this.addEvent()
      this.util.addMtah5ClickStat('exhibition_' + this.id)
    }
    if (this.$route.query.activityId === '5') {
      this.hidePeople = true
    }
  },
  methods: {
    toUrl (url) {
      window.open(url)
    },
    addEvent () {
      let params = {
        statId: this.$store.state.sid,
        eventId: 'exhibition_' + this.id
      }
      this.$api.addEvent(params).then(res => {
      })
    },
    addZan () {
      if (!this.isZan) {
        let params = {
          type: 1,
          id: this.id
        }
        this.$api.addZan(params).then(res => {
          this.isZan = true
          this.exhibitionData.thumbNum = this.exhibitionData.thumbNum + 1
        })
      }
    },
    imgWidthAndHeight (src, callback) {
      let image = new Image()
      image.src = src
      image.onload = function () {
        return callback(image.width, image.height)
      }
    },
    unitSlideChange (index) {
      this.unitIndex = index
    },
    showImageCover (index) {
      this.$refs.coverSwiper.swiper.slideTo(index, 500, false)
      this.coverSwiperIndex = index
      this.imgCoverShow = true
    },
    getDetailInfo () {
      this.$api.getExhibitionInfo(this.id).then(res => {
        this.exhibitionData = res.data.data
        // 标题适配
        let titleBoxMaxWidth = 500
        let halfTitle = this.exhibitionData.title.length / 2
        let fontSizeTemp = titleBoxMaxWidth / halfTitle
        if (fontSizeTemp < 42) {
          document.querySelector('#exhibitionTitle').style.fontSize = Math.floor(fontSizeTemp) + 'px'
        }

        // 实况视频和展厅图片
        this.videoArray = []
        if (this.exhibitionData['5005']) {
          this.exhibitionData['5005'].forEach((el, i) => {
            let json = el
            json.type = json.type.split('/')[0]
            json['videoUrl'] = json.url
            json['url'] = '/temp/video-temp1.png'
            json['videoPlay'] = false
            this.videoArray = this.videoArray.concat(json)
          })
        }
        if (this.exhibitionData['5001']) {
          this.exhibitionData['5001'].forEach((el, i) => {
            let json = el
            json.type = json.type.split('/')[0]
            this.videoArray = this.videoArray.concat(json)
          })
        }

        // 全景链接
        // if (this.exhibitionData['5004'] && this.exhibitionData['5004'].length > 0 && this.exhibitionData['5004'][0].url) {
        //   this.exhibitionData.vrUrl = this.exhibitionData['5004'][0].url
        // }

        // 文物图片
        this.antiqueSwiper = this.exhibitionData.antiqueArray
        if (this.antiqueSwiper && this.antiqueSwiper.length > 0) {
          this.$nextTick(() => {
            this.$refs.exhibitSwiper.swiper.update()
          })
        }
        // let antiqueArray = this.exhibitionData.antiqueArray
        // antiqueArray.forEach((el, i) => {
        //   let json = {}
        //   json = el
        //   this.imgWidthAndHeight(el.cover, (w, h) => {
        //     json['w'] = w
        //     json['h'] = h
        //     this.antiqueSwiper.push(json)
        //     if (this.antiqueSwiper.length === antiqueArray.length) {
        //       this.makeWaterfalls()
        //     }
        //   })
        // })

        // 介绍展开收起判断
        this.$nextTick(() => {
          if (this.$refs.introduction && this.$refs.introduction.clientHeight > 136) {
            this.introShowAll = false
            this.introductionShowBtn = true
          } else {
            this.introShowAll = true
            this.introductionShowBtn = false
          }
        })

        // 单元展开收起判断
        this.checkUnitShowBtn()

        // 媒体资讯展开收起判断
        if (this.exhibitionData.reportArray.length > 6) {
          this.mediaShowBtn = true
        } else {
          this.mediaShowBtn = false
        }

        // 如果activityId是5，即2021年十大精品展，则隐藏策展团队
        if (this.exhibitionData.activityId === 5) {
          this.hidePeople = true
        }
      })
    },
    makeWaterfalls () {
      this.antiqueSwiper.forEach((el, i) => {
        el['index'] = i
        if (this.topListWidth <= this.bottomListWidth) {
          this.topList.push(el)
          let w = this.topListHeight / el.h * el.w
          this.topListWidth = this.topListWidth + Math.ceil(w) + 10
          // console.log('top', this.topListWidth, w)
        } else {
          this.bottomList.push(el)
          let w = this.bottomListHeight / el.h * el.w
          this.bottomListWidth = this.bottomListWidth + Math.ceil(w) + 10
          // console.log('bottom', this.bottomListWidth, w)
        }
      })
      setTimeout(() => {
        this.$refs.exhibitSwiper.swiper.update()
      }, 1000)
    },
    checkUnitShowBtn () {
      this.unitShowAll = true
      this.$nextTick(() => {
        if (this.$refs.unitIntro && this.$refs.unitIntro.clientHeight > 132) {
          this.unitShowAll = false
          this.unitIntroShowBtn = true
        } else {
          this.unitShowAll = true
          this.unitIntroShowBtn = false
        }
      })
    },
    playVideo (url) {
      this.videoCoverShow = true
      this.videoPlayUrl = url
    },
    closeVideo () {
      this.videoCoverShow = false
      this.videoPlayUrl = ''
    },
    showActiveInfo (active) {
      this.activeJson = active
      this.activeImgCoverShow = true
    },
    hideActiveInfo () {
      this.activeJson = {}
      this.activeImgCoverShow = false
    }
  },
  computed: {
    showTime () {
      if (this.exhibitionData.closeTime) {
        return this.exhibitionData.curtainTime.split(' ')[0] + ' ~ ' + this.exhibitionData.closeTime.split(' ')[0]
      } else {
        return this.exhibitionData.curtainTime.split(' ')[0] + ' ~ ' + '长期'
      }
    }
  }
}
</script>
<style lang="scss">
  .detail{
    .have-icon-title{
      display: inline-block;
      font-weight: bold;
      font-size: 24px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      line-height: 24px;
      position: relative;
      margin-bottom: 20px;
      &::before{
        content: ' ';
        width: 79px;
        height: 16px;
        background: url("../assets/images/title-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        left: -107px;
        margin-top: -8px;
      }
      &::after{
        content: ' ';
        width: 79px;
        height: 16px;
        background: url("../assets/images/title-right.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        top: 50%;
        right: -107px;
        margin-top: -8px;
      }
    }
    .more-btn{
      width: 100%;
      display: inline-block;
      font-size: 12px;
      color: #35343D;
      letter-spacing: 0;
      /*text-align: justify;*/
      line-height: 12px;
      padding-right: 15px;
      position: relative;
      cursor: pointer;
      text-align: center;
      &::after{
        content: ' ';
        width: 12px;
        height: 8px;
        background: url("../assets/images/show-more.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: auto;
        top: 2px;
      }
      &.up{
        &::after{
          transform: rotateZ(180deg);
        }
      }
    }
    .top-image-box{
      width: 100%;
      height: 416px;
      overflow: visible;
      position: relative;
      /*margin-bottom: 60px;*/
      .background-box{
        width: 100%;
        height: 416px;
        overflow: hidden;
        position: absolute;
        left: 0;
        top: 0;
        .background{
          width: 100%;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .cover{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(270deg, rgba(24,39,45,0.00) 0%, rgba(11,19,23,0.70) 49%, rgba(11,18,21,0.79) 72%, rgba(11,18,21,0.80) 75%, rgba(10,17,20,0.90) 100%, rgba(10,17,20,0.90) 100%);
        backdrop-filter: blur(30px);
      }
      .content-box{
        position: relative;
        height: 416px;
        .cover-img{
          width: 258px;
          height: 376px;
          position: absolute;
          top: 20px;
          right: 255px;
          img{
            width: 258px;
            height: 376px;
          }
        }
        .pano-btn{
          width: 70px;
          height: 100px;
          position: absolute;
          top: 149px;
          right: 349px;
          cursor: pointer;
          i{
            display: block;
            width: 70px;
            height: 70px;
            background: url("../assets/images/360.png") no-repeat 0 0;
            background-size: 100% 100%;
            margin-bottom: 15px;
            border-radius: 50%;
            box-shadow: 1px 1px 2px #000000;
          }
          p{
            font-size: 15px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            line-height: 15px;
            text-shadow: 1px 1px 2px #000000;
          }
        }
        .intro-box{
          position: absolute;
          top: 67px;
          left: 103px;
          max-width: 500px;
          h2{
            font-size: 42px;
            color: #FFFFFF;
            line-height: 42px;
            font-weight: bold;
            margin-bottom: 15px;
          }
          h3{
            font-size: 20px;
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: justify;
            line-height: 20px;
            margin-bottom: 20px;
          }
          .museum{
            height: 40px;
            margin-bottom: 20px;
            img{
              float: left;
              box-sizing: border-box;
              width: 38px;
              height: 38px;
              border: 1px solid #ffffff;
              border-radius: 50%;
            }
            p{
              float: left;
              font-size: 12px;
              color: #FFFFFF;
              letter-spacing: 0;
              line-height: 40px;
              margin-left: 12px;
              /*text-decoration: underline;*/
            }
          }
          ul{
            li{
              font-size: 12px;
              color: #FFFFFF;
              letter-spacing: 0;
              line-height: 26px;
              position: relative;
              a{
                color: #FFFFFF;
                text-decoration: underline;
                display: inline-block;
                position: relative;
              }
              i{
                display: block;
                width: 12px;
                height: 14px;
                position: absolute;
                top: 6px;
                right: -20px;
                background: url("../assets/images/location.png") no-repeat 0 0;
                background-size: 100% 100%;
              }
            }
          }
        }
        .zan-btn{
          box-sizing: border-box;
          width: 110px;
          height: 70px;
          border: 1px solid #E4E4E5;
          border-radius: 8px;
          position: absolute;
          right: 132px;
          bottom: -95px;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .zan-image-box{
            margin-left: 8px;
            width: 41px;
            height: 40px;
            position: relative;
            img{
              margin: 11px 0 0 10px;
              width: 21px;
              height: 18px;
            }
            .zan-num{
              width: 40px;
              font-size: 12px;
              line-height: 12px;
              color: #4A4A4A;
              position: absolute;
              left: 0;
              bottom: -4px;
              text-align: center;
            }
            .zan-tip{
              width: 40px;
              font-size: 12px;
              line-height: 12px;
              color: #FE0C24;
              position: absolute;
              left: 0;
              top: -4px;
              text-align: center;
              opacity: 0;
              transform: translateY(0);
              &.like{
                animation: addZan 2s forwards;
              }
            }
          }
          .tip{
            margin-right: 20px;
            display: inline-block;
            font-size: 18px;
            line-height: 40px;
            color: #4A4A4A;
          }
        }
      }
    }
    .introduction{
      text-align: center;
      margin-top: 60px;
      margin-bottom: 30px;
      .intro{
        margin: 0 auto;
        width: 666px;
        font-size: 13px;
        color: #4A4A4A;
        letter-spacing: 0;
        text-align: justify;
        line-height: 34px;
        margin-bottom: 30px;
        max-height: 136px;
        overflow: hidden;
        text-indent: 2em;
        &.all{
          max-height: none;
        }
      }
    }
    .video-swiper-box{
      position: relative;
      margin-bottom: 60px;
      .big-img{
        width: 666px;
        height: 350px;
        margin: 0 auto 10px;
        font-size: 0;
        position: relative;
        img{
          width: 666px;
          height: 350px;
        }
        video{
          width: 666px;
          height: 350px;
        }
        .cover{
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(0,0,0,0.00) 67%, #000000 100%);
        }
        p{
          position: absolute;
          left: 30px;
          bottom: 20px;
          font-size: 13px;
          line-height: 18px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: justify;
        }
        .play-btn{
          width: 50px;
          height: 50px;
          background: url("../assets/images/play-btn.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          left: 50%;
          top: 50%;
          margin-left: -25px;
          margin-top: -25px;
          cursor: pointer;
        }
      }
      .thumb-swiper{
        width: 666px;
        height: 68px;
        position: relative;
        .slide{
          width: 129px;
          height: 68px;
          /*margin-right: 5px;*/
          font-size: 0;
          /*&:nth-last-of-type(1){*/
            /*margin-right: 0;*/
          /*}*/
          opacity: 0.6;
          &.show{
            opacity: 1;
          }
          video,img{
            width: 129px;
            height: 68px;
          }
        }
      }
      .thumb-swiper-area{
        width: 666px;
        height: 68px;
        position: relative;
        margin: 0 auto;
      }
      .swiper-button-prev1{
        width: 34px;
        height: 34px;
        background: url("../assets/images/swiper-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: -39px;
        top: 17px;
        margin-top: 0;
      }
      .swiper-button-next1{
        width: 34px;
        height: 34px;
        background: url("../assets/images/swiper-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        right: -39px;
        top: 17px;
        transform: rotateZ(180deg);
        margin-top: 0;
      }
      .video{
        background: #000000;
      }
    }
    .unit-intro-box{
      text-align: center;
      .have-icon-title{
        margin-bottom: 60px;
      }
      .unit-swiper-box{
        width: 666px;
        margin: 0 auto 30px;
        .unit-swiper{
          box-sizing: border-box;
          width: 666px;
          height: 180px;
          padding-left: 65px;
        }
        .slide{
          width: 115px;
          height: 115px;
          position: relative;
          cursor: pointer;
          margin-right: 18px;
          margin-top: 32.5px;
          /*transform: scale3d(0.64, 0.64, 1);*/
          /*transition: transform 0.3s;*/
          &:nth-last-of-type(1){
            margin-right: 486px;
          }
          img{
            width: 115px;
            height: 115px;
          }
          .cover{
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.6);
            p{
              width: 100%;
              text-align: center;
              font-size: 20px;
              color: #FFFFFF;
              letter-spacing: 0;
              text-align: center;
              line-height: 20px;
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
        .active{
          width: 180px;
          height: 180px;
          margin-top: 0;
          img{
            width: 180px;
            height: 180px;
          }
        }
      }
      .intro-box{
        width: 666px;
        margin: 0 auto 60px;
        .title{
          text-align: left;
          font-size: 16px;
          color: #000000;
          letter-spacing: 0;
          line-height: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .intro{
          font-size: 13px;
          color: #4A4A4A;
          letter-spacing: 0;
          text-align: justify;
          line-height: 33px;
          margin-bottom: 30px;
          max-height: 132px;
          overflow: hidden;
          text-indent: 2em;
          &.all{
            max-height: none;
          }
        }
      }
    }
    .exhibits-area{
      position: relative;
      .swiper-button-prev2{
        width: 34px;
        height: 34px;
        background: url("../assets/images/swiper-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: 220px;
        top: 140px;
      }
      .swiper-button-next2{
        width: 34px;
        height: 34px;
        background: url("../assets/images/swiper-left.png") no-repeat 0 0;
        background-size: 100% 100%;
        transform: rotateZ(180deg);
        position: absolute;
        right: 220px;
        top: 140px;
      }
    }
    .exhibits-box{
      width: 666px;
      margin: 0 auto 60px;
      text-align: center;
      .have-icon-title{
        margin-bottom: 60px;
      }
      .exhibit-swiper{
        width: 100%;
        height: 150px;
        text-align: left;
        .slide{
          white-space: nowrap;
          width: auto;
          /*width: 100%;*/
        }
        .exhibit-line{
          white-space: nowrap;
          height: 150px;
          margin-bottom: 10px;
          .img-box{
            display: inline-block;
            padding-right: 10px;
            font-size: 0;
            cursor: pointer;
            position: relative;
          }
          img{
            height: 150px;
          }
        }
      }
    }
    .media-info-box{
      text-align: center;
      margin-bottom: 60px;
      .have-icon-title{
        margin-bottom: 60px;
      }
      ul{
        width: 746px;
        margin: 0 auto;
        max-height: 510px;
        overflow: hidden;
        &.all{
          max-height: none;
        }
        li{
          width: 343px;
          height: 110px;
          margin-right: 60px;
          margin-bottom: 60px;
          cursor: pointer;
          &:nth-of-type(2n){
            margin-right: 0;
          }
          img{
            float: left;
            width: 150px;
            height: 110px;
          }
          .info-box{
            float: left;
            width: 183px;
            height: 110px;
            margin-left: 10px;
            position: relative;
            h5{
              text-align: left;
              font-size: 16px;
              color: #000000;
              letter-spacing: 0;
              line-height: 22px;
            }
            p{
              text-align: left;
              font-size: 16px;
              color: #5D5D5D;
              letter-spacing: 0;
              line-height: 22px;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }
        }
      }
    }
    .team-box{
      text-align: center;
      .main-box{
        width: 666px;
        margin: 0 auto 40px;
        img{
          width: 100px;
          height: 100px;
          margin-bottom: 30px;
          border-radius: 50%;
        }
        h3{
          font-size: 20px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          margin-bottom: 16px;
        }
        h4{
          font-size: 20px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          margin-bottom: 40px;
        }
        p{
          font-size: 13px;
          color: #4A4A4A;
          letter-spacing: 0;
          text-align: center;
          line-height: 33px;
          &.text{
            text-align: justify;
            text-indent: 2em;
          }
        }
      }
      .other-box{
        width: 666px;
        margin: 0 auto 80px;
        padding-top: 40px;
        border-top: 1px dashed #b1b1b1;
        h4{
          font-size: 20px;
          color: #000000;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          margin-bottom: 30px;
        }
        ul{
          width: 640px;
          margin: 0 auto;
          max-height: 165px;
          overflow: hidden;
          margin-bottom: 20px;
          &.all{
            max-height: none;
          }
        }
        li{
          width: 80px;
          height: 135px;
          margin-right: 60px;
          margin-bottom: 30px;
          &:nth-of-type(5n){
            margin-right: 0;
          }
          img{
            width: 80px;
            height: 80px;
            border-radius: 50%;
            margin-bottom: 15px;
          }
          h5{
            font-size: 15px;
            color: #000000;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
          }
          h6{
            font-size: 13px;
            color: #000000;
            letter-spacing: 0;
            text-align: center;
            line-height: 20px;
          }
        }
      }
    }
    .img-cover-box{
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.85);
      z-index: 101;
      .close-btn{
        width: 40px;
        height: 40px;
        background: url("../assets/images/close-btn.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        right: 80px;
        top: 40px;
        z-index: 1;
        cursor: pointer;
      }
      .wrapBox{
        height: 100vh;
        position: relative;
      }
      .cover-swiper-box{
        width: 600px;
        height: 500px;
        position: absolute;
        left: 20px;
        top: 50%;
        margin-top: -250px;
        .cover-swiper{
          margin-left: 50px;
          width: 500px;
          height: 500px;
          .slide{
            width: 500px;
            height: 500px;
            position: relative;
            .loading{
              width: 40px;
              height: 40px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate3d(-50%, -50%, 0);
            }
            img{
              max-width: 100%;
              max-height: 100%;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate3d(-50%, -50%, 0);
            }
          }
        }
        .swiper-button-prev3,.swiper-button-prev4{
          width: 40px;
          height: 40px;
          background: url("../assets/images/swiper-left.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          left: 0;
          top: 50%;
          margin-top: -20px;
        }
        .swiper-button-next3,.swiper-button-next4{
          width: 40px;
          height: 40px;
          background: url("../assets/images/swiper-left.png") no-repeat 0 0;
          background-size: 100% 100%;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -20px;
          transform: rotateZ(180deg);
        }
      }
      .intro-box{
        width: 500px;
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        h2{
          font-size: 24px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 33px;
          font-weight: bold;
          padding-bottom: 20px;
          border-bottom: 1px solid rgba(255,255,255,0.5);
          margin-bottom: 40px;
        }
        p{
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 40px;
        }
      }
    }
    .video-cover-box{
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.85);
      z-index: 101;
      .close-btn{
        width: 40px;
        height: 40px;
        background: url("../assets/images/close-btn.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        right: 80px;
        top: 40px;
        z-index: 1;
        cursor: pointer;
      }
      .wrapBox{
        height: 100vh;
        position: relative;
        video{
          max-width: 1200px;
          max-height: 500px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate3d(-50%, -50%, 0);
        }
      }
    }

  }

  @keyframes addZan {
    0% {
      transform: translateY(4px);
      opacity: 0;
    }
    40% {
      transform: translateY(0);
      opacity: 1;
    }
    80% {
      transform: translateY(0);
      opacity: 1;
    }
    100% {
      transform: translateY(0);
      opacity: 0;
    }
  }

</style>
